import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestBiztrip } from "../../entity/EntityRequestBiztrip";

export class DtoRequestBiztripsPostReq extends EntityRequestBiztrip {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
